export const baseSpacingPixelValue = 4;
export const spacing = (...x) => {
    return x.map(n => `${n * baseSpacingPixelValue}px`).join(' ');
};
export const borderRadius = {
    sm: '4px',
    md: '8px',
    full: '9999px',
};
export const rowGap = {
    tiny: '4px',
    extraSmall: '10px',
    small: '20px',
    medium: '40px',
    large: '80px',
};
//# sourceMappingURL=spacing.js.map